import { C_AMBER, rgba } from '../utils/palette';
import { setupCanvas } from '../utils/canvas';
import { YEARS } from '../utils/constants';

export const CHART_KEY = [
    'X = rider (top 20) · Y = ranking points · grouped by season',
    'Darker bar = more recent year',
    'Tap a bar for rider name and exact points',
];

const yearColors = [rgba(C_AMBER, 0.25), rgba(C_AMBER, 0.5), rgba(C_AMBER, 0.85)];

/**
 * @param {HTMLCanvasElement} canvas
 * @param {HTMLElement} tooltip
 * @param {Array} riders
 */
export function renderYoyBar(canvas, tooltip, riders) {
    if (!canvas || !riders.length) return;
    const top20 = riders.slice(0, 20);

    const w    = canvas.parentElement.clientWidth || 280;
    const rowH = 14;
    const h    = top20.length * rowH + 24;
    const ctx  = setupCanvas(canvas, w, h);
    ctx.clearRect(0, 0, w, h);

    const maxPts = Math.max(...top20.map(r => r.points || 0), 1);
    const pad    = { top: 16, right: 8, bottom: 4, left: 24 };
    const barW   = w - pad.left - pad.right;

    YEARS.forEach((yr, yi) => {
        const lx = pad.left + yi * 36;
        ctx.fillStyle = yearColors[yi];
        ctx.fillRect(lx, 2, 8, 8);
        ctx.fillStyle = '#aaa';
        ctx.font = '8px monospace';
        ctx.textAlign = 'left';
        ctx.fillText(yr.slice(2), lx + 10, 10);
    });

    const hitRows = [];
    top20.forEach((rider, i) => {
        const y = pad.top + i * rowH;
        let xBase = pad.left;
        YEARS.forEach((yr, yi) => {
            const pts = rider.pointsByYear?.[yr] || 0;
            if (!pts) return;
            const bw = (pts / maxPts) * barW;
            ctx.fillStyle = yearColors[yi];
            ctx.fillRect(xBase, y + 2, bw, rowH - 4);
            xBase += bw;
        });

        ctx.fillStyle = '#bbb';
        ctx.font = '8px monospace';
        ctx.textAlign = 'right';
        ctx.textBaseline = 'middle';
        ctx.fillText(rider.position, pad.left - 4, y + rowH / 2);

        hitRows.push({ y, rowH, name: rider.rider, pts: rider.points, pos: rider.position });
    });
    ctx.textBaseline = 'alphabetic';

    if (canvas._yoyMM) canvas.removeEventListener('mousemove',  canvas._yoyMM);
    if (canvas._yoyML) canvas.removeEventListener('mouseleave', canvas._yoyML);
    canvas._yoyMM = (e) => {
        const rect = canvas.getBoundingClientRect();
        const my   = e.clientY - rect.top;
        const hit  = hitRows.find(r => my >= r.y && my < r.y + r.rowH);
        if (hit && tooltip) {
            tooltip.textContent   = `${hit.pos}  ${hit.name}`;
            tooltip.style.display = 'block';
            const _mx1 = e.clientX - rect.left;
            const _tw1 = tooltip.offsetWidth;
            tooltip.style.left    = (_mx1 + 10 + _tw1 > canvas.parentElement.clientWidth ? _mx1 - _tw1 - 10 : _mx1 + 10) + 'px';
            tooltip.style.top     = (e.clientY - rect.top - 24) + 'px';
        } else if (tooltip) {
            tooltip.style.display = 'none';
        }
    };
    canvas._yoyML = () => { if (tooltip) tooltip.style.display = 'none'; };
    canvas.addEventListener('mousemove',  canvas._yoyMM);
    canvas.addEventListener('mouseleave', canvas._yoyML);
}
